import { useState, useContext, useMemo } from "react";
import Cases from "./Cases";
import AddCase from "./AddCase";
import AddCaseModal from "./AddCaseModal";
import AuthContext from "../context/AuthProvider";

import DashboardTop from "./Updates/DashboardTop";
import DesktopAppBanner from "./DesktopAppBanner";
import useCases from "../features/cases/useCases";
import { matchesSearch } from "../features/cases/caseFilters";

const Admin = () => {
  const { allCases, addCase, removeCase, updateCase } = useCases();
  const [prothesmies] = useState([]);
  const { credits, setCredits } = useContext(AuthContext);

  const [search, setSearch] = useState("");

  const cases = useMemo(
    () => (search ? allCases.filter((c) => matchesSearch(c, search)) : allCases),
    [allCases, search]
  );

  const [showModal, setShowModal] = useState(true);
  const handleClickAddCaseModal = (e) => {
    console.log(e?.key);
    if (e?.key === "Escape") {
      setShowModal(true);
    }
    if (e?.key === "Enter") {
      setShowModal(false);
      console.log(e.key);
    }
    if (!e?.key) {
      console.log(e);
      setShowModal(!showModal);
    }
  };
  const handleAddCase = addCase;
  const handleDeleteCase = removeCase;
  const handleAddSelectedDiadikasia = (caseId, diadikasia) => {
    updateCase(caseId, {
      userInput: [
        {
          category: "select_diadikasia",
          data: JSON.stringify(diadikasia),
        },
      ],
    });
  };

  return (
    <section className="astika">
      <section className="container_info">
        {/* <RotatingElements /> */}
        <DesktopAppBanner />

        <section className="container_search">
          {/* <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p> */}

          {/* <div className="close_addcase"><p onClick={() => handleClickAddCaseModal()}>❌</p></div> */}
          {/* <span></span> */}
          <form className="form_search">
            {/* <label htmlFor="username">Email:</label> */}
            <div className="input-container ic1">
              <input
                className="input"
                placeholder=" "
                type="text"
                id="Αναζήτηση"
                autoComplete="on"
                onChange={(e) => setSearch(e.target.value)}
                value={search || ""}
                required
              />
              <div className="cut"></div>
              <label htmlFor="Αναζήτηση" className="placeholder">
                🔎 Αναζήτηση (πχ. Αθηνών)
              </label>
            </div>

            {/* <label htmlFor="password">Password:</label> */}
          </form>
        </section>

        {showModal ? (
          <AddCaseModal handleClickAddCaseModal={handleClickAddCaseModal} />
        ) : (
          <AddCase
            handleClickAddCaseModal={handleClickAddCaseModal}
            allCases={allCases}
            handleAddCase={handleAddCase}
            credits={credits}
            setCredits={setCredits}
          />
        )}
        <p className="courts-info">
          Τα δικαστήρια προς χάριν συντομίας εμφανίζονται, όπως εμφανίζονταν προ
          του Νέου Δικαστικού Χάρτη. Πχ. Το "Πρωτοδικείο Αθηνών (Πρώην
          Ειρηνοδικείο Αχαρνών)" εμφανίζεται ως "ΕΙΡ. ΑΧΑΡΝΩΝ". Παρακαλώ ελέγξτε
          ότι σας επιστρέφονται τα σωστά στοιχεία της υπόθεσής σας κατά την
          εισαγωγή.
        </p>
        <Cases
          prothesmies={prothesmies}
          cases={cases}
          handleDeleteCase={handleDeleteCase}
          handleAddSelectedDiadikasia={handleAddSelectedDiadikasia}
          credits={credits}
          setCredits={setCredits}
        />
      </section>
      {cases.length > 0 && (
        <section className="dashboard-astika">
          <DashboardTop cases={cases} columns={1} />
        </section>
      )}
    </section>
  );
};

export default Admin;
